import { appRoute } from "routes/app/home.runtime"
import { registerConditionalPageNavigation } from "lib/routes/register-conditional-page-navigation"
import { getDemandForFeature } from "lib/features"
import { checkPermission } from "library/authorization/index.mjs"
import { hasDemand } from "lib/authorization/has-demand"
import { RecycleType } from "event-definitions"
import { FEATURE_FLAG_OPTIMISER } from "./feature-flag-optimiser"
// Import only for its registration side effect. The conditional-trades UI imports the
// flag constant directly from the feature-flag-conditional-trades module.
import "./feature-flag-conditional-trades"
import "./feature-flag-promote-regime"
import "./feature-flag-schedule-assignments"
import { OptimiserPage } from "./optimiser-page"
import { SkillMapView } from "./plugins/skill-mappings/skill-map-view"
import { RateCardView } from "./plugins/rate-cards/rate-card-view"
import { RuleSetView } from "./plugins/rule-sets/rule-set-view"
import { CreateScenarioPage } from "./plugins/scenarios/create-scenario-page"
import { ScenarioView } from "./plugins/scenarios/scenario-view"
import { VariantComparison } from "./plugins/scenarios/variant-comparison"
import { ScenarioRuleSetEditorView } from "./plugins/scenarios/scenario-rule-set-editor-view"
import { OptimiserAccessGate } from "./optimiser-access-gate"
import { LegacyRouteRedirect } from "./legacy-route-redirect"
const featureDemand = `$${getDemandForFeature(FEATURE_FLAG_OPTIMISER)}`

// Both legacy URL families redirect to /app/optimiser (FIQ-2130); see legacy-route-redirect.js
appRoute.register("scenario-planner", <LegacyRouteRedirect />)
appRoute.register("scenario-planner/*", <LegacyRouteRedirect />)
appRoute.register("cost-modeller", <LegacyRouteRedirect />)
appRoute.register("cost-modeller/*", <LegacyRouteRedirect />)

// Route: /app/optimiser
appRoute.register(
    "optimiser",
    <OptimiserAccessGate productDemand={featureDemand} demands="viewCosting">
        <OptimiserPage $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/skill-mappings/:id
appRoute.register(
    "optimiser/skill-mappings/:id",
    <OptimiserAccessGate productDemand={featureDemand} demands="viewCosting">
        <SkillMapView $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/rate-cards/:id
appRoute.register(
    "optimiser/rate-cards/:id",
    <OptimiserAccessGate productDemand={featureDemand} demands="viewCosting">
        <RateCardView $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/rule-sets/:id
appRoute.register(
    "optimiser/rule-sets/:id",
    <OptimiserAccessGate productDemand={featureDemand} demands="viewCosting">
        <RuleSetView $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/scenarios/create
appRoute.register(
    "optimiser/scenarios/create",
    <OptimiserAccessGate productDemand={featureDemand} demands="manageScenarios">
        <CreateScenarioPage $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/scenarios/:id
appRoute.register(
    "optimiser/scenarios/:id",
    <OptimiserAccessGate productDemand={featureDemand} demands="viewCosting">
        <ScenarioView $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/scenarios/:id/rules
appRoute.register(
    "optimiser/scenarios/:id/rules",
    <OptimiserAccessGate productDemand={featureDemand} demands="manageScenarios">
        <ScenarioRuleSetEditorView $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/scenarios/:id/compare
appRoute.register(
    "optimiser/scenarios/:id/compare",
    <OptimiserAccessGate productDemand={featureDemand} demands="viewCosting">
        <VariantComparison $lazy />
    </OptimiserAccessGate>
)

// Route: /app/optimiser/scenarios/:id/edit
appRoute.register(
    "optimiser/scenarios/:id/edit",
    <OptimiserAccessGate productDemand={featureDemand} demands="manageScenarios">
        <CreateScenarioPage $lazy />
    </OptimiserAccessGate>
)

// Sidebar: "Optimiser" entry
registerConditionalPageNavigation(
    () => checkPermission(featureDemand) && hasDemand("!sharing") && checkPermission("viewCosting"),
    "/app/optimiser",
    "Optimiser",
    "mdi:chart-bar",
    {
        group: "Planning",
        priority: 160,
        subPaths: true,
    }
)

RecycleType.handle(({ item }) => {
    if (item.type === "scenario") {
        return { type: "Scenario" }
    }
    return undefined
})
